<template>
  <div class="app-checkout-auto-top-up-wrapper">
    <div class="text">
      <slot name="txtBeforeAutoTopUp"></slot>
    </div>
    <b-form-checkbox-group v-model="selectedTopUpTypes_">
      <b-col cols="12" class="without-auto-wrapper">
        <b-form-checkbox value="without" @change="change($event, 'without')">
          <slot name="lblWithoutAuto">Ohne Aufladung fortfahren</slot>
        </b-form-checkbox>
      </b-col>
      <b-col cols="12" class="single-top-up-wrapper">
        <b-form-checkbox value="single" @change="change($event, 'single')">
          <div class="single-topup-label">
            <slot name="lblSingleTopUp"></slot>
          </div>
        </b-form-checkbox>
        <single-top-up
          v-if="showSingleTopUp"
          :amounts="topUpAmounts.directAmounts.amount"
          :defaultAmount="topUpAmounts.directAmounts.default"
          :single-top-up.sync="singleTopUp_"
        >
          <template v-for="slot in possibleChildSlotsFor('SingleTopUp')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </single-top-up>
      </b-col>
      <b-col cols="12" class="auto-top-up-wrapper">
        <b-form-checkbox value="auto" @change="change($event, 'auto')">
          <slot name="txtAutoBeforeRadio"></slot>
        </b-form-checkbox>
        <b-form-radio-group required
                            v-if="showAutoTopUp"
                            class="top-up-group"
                            v-model="splittedTopUp"
        >
          <auto-top-up
            :top-up="autoTopUp_"
            :trigger.sync="autoTopUp_.trigger"
            :amount.sync="autoTopUp_.amount"
            :auto-amounts="topUpAmounts.autoAmounts"
            :inside-activation="true"
          >
            <template v-for="slot in possibleChildSlotsFor('AutoTopUp')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </auto-top-up>
        </b-form-radio-group>
        <div v-if="!showAutoTopUp" class="auto-topup-description">
          <slot name="txtAutoDescription">Die einfachste und komfortabelste Art, immer genügend Guthaben auf deinem FYVE Konto zu haben, ist die automatische Aufladung. Dein Guthaben wird regelmäßig bei Unterschreitung einer bestimmten Guthabengrenze oder jeweils zum 2. jedes Monats automatisch aufgeladen. Die Einstellungen kannst du nachträglich jederzeit ändern.</slot>
        </div>
      </b-col>
    </b-form-checkbox-group>
  </div>
</template>

<script>
import SingleTopUp from '@/components/process/FYVE/Activation/TopUp/SingleTopUp.vue'
import AutoTopUp from '@/components/process/generic/Order/otelo/AutoTopUp.vue'
import syncProperty from '@/mixins/syncProperty'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'CheckoutTopUpWrapper',
  mixins: [
    syncProperty('autoTopUp', 'autoTopUp_'),
    syncProperty('singleTopUp', 'singleTopUp_'),
    syncProperty('selectedTopUpTypes', 'selectedTopUpTypes_'),
    slotProxy()
  ],
  methods: {
    change (newValue, changedItem) {
      if (newValue.includes('without') && newValue.length > 1) {
        // invalid!, without + 1 other option
        if (changedItem === 'without') {
          // last change was clicking without -> all other values must be deselected
          this.selectedTopUpTypes_ = ['without']
        } else {
          // clicked anoter, without must be removed
          this.selectedTopUpTypes_ = [
            ...newValue.filter(item => item !== 'without')
          ]
        }
      } else if (newValue.length === 0) {
        // empty is not good, select all available types
        if (changedItem === 'without') {
          this.selectedTopUpTypes_ = [
            'auto',
            'single'
          ]
        } else {
          this.selectedTopUpTypes_ = ['without']
        }
      } else {
        this.selectedTopUpTypes_ = newValue
      }
    }
  },
  computed: {
    splittedTopUp: {
      get: function () {
        return {
          type: this.autoTopUp_.type
        }
      },
      set: function (value) {
        this.autoTopUp_.type = value.type
        if (value.type === 'withoutAuto') {
          this.autoTopUp_.trigger = null
          this.autoTopUp_.amount = null
        }
        if (value.type === 'monthly') {
          this.autoTopUp_.trigger = value.trigger
        }
      }
    },
    showSingleTopUp () {
      return this.selectedTopUpTypes_.includes('single')
    },
    showAutoTopUp () {
      return this.selectedTopUpTypes_.includes('auto')
    }
  },
  components: { AutoTopUp, SingleTopUp },
  props: {
    topUpAmounts: {
      type: Object
    }
  }
}
</script>
